import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card border-0 bg-white profile-settings-card rounded-0" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_7 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, null, -1 /* HOISTED */)
const _hoisted_16 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_19 = {
  value: null,
  key: -1
}
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "form-messages mt-2 px-1"
}
const _hoisted_22 = {
  key: 1,
  class: "col-12"
}
const _hoisted_23 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_24 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_25 = {
  key: 0,
  type: "button",
  class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium",
  "data-bs-toggle": "modal",
  "data-bs-target": "#confirmModal"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "ph ph-trash lh-1 me-1 position-relative top-2" }, null, -1 /* HOISTED */)
const _hoisted_27 = { class: "position-relative" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "d-flex flex-wrap gap-3 justify-content-end ms-auto" }
const _hoisted_30 = { class: "row justify-content-center" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0 mb-25",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_DiscardButton = _resolveComponent("DiscardButton")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_RolePermissions = _resolveComponent("RolePermissions")!
  const _component_RoleConsents = _resolveComponent("RoleConsents")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", {
          onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createCommentVNode(" NAME "),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('form.name.label')) + "* ", 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.role.name) = $event)),
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.name }]]),
                  required: ""
                }, null, 2 /* CLASS */), [
                  [_vModelText, _ctx.role.name]
                ]),
                _createCommentVNode(" ERRORS "),
                (_ctx.errors?.name ?? false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.name, (error) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: error,
                          class: "small text-danger lh-1 m-0 mt-1"
                        }, _toDisplayString(error), 1 /* TEXT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _hoisted_8,
            _createCommentVNode(" ROLE "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('feature.roles.type')) + "* ", 1 /* TEXT */),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.type }]]),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.role.type) = $event)),
                    required: "",
                    disabled: _ctx.update
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: type,
                        key: type
                      }, _toDisplayString(_ctx.$t(`feature.roles.$type.${type}`)), 9 /* TEXT, PROPS */, _hoisted_13))
                    }), 128 /* KEYED_FRAGMENT */))
                  ], 10 /* CLASS, PROPS */, _hoisted_12), [
                    [_vModelSelect, _ctx.role.type]
                  ]),
                  _createCommentVNode(" ERRORS "),
                  (_ctx.errors?.type ?? false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.type, (error) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: error,
                            class: "small text-danger lh-1 m-0 mt-1"
                          }, _toDisplayString(error), 1 /* TEXT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ]),
            _hoisted_15,
            _createCommentVNode(" ZONE "),
            (_ctx.role.type === _ctx.Role.internal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('feature.roles.zone')), 1 /* TEXT */),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select shadow-none text-black fs-md-15", [{ 'is-invalid': _ctx.submitted && _ctx.errors?.zone_id }]]),
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.role.zone_id) = $event))
                      }, [
                        (_openBlock(), _createElementBlock("option", _hoisted_19, _toDisplayString(), 1 /* TEXT */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (zone) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: zone.id,
                            key: zone.id!
                          }, _toDisplayString(zone.name), 9 /* TEXT, PROPS */, _hoisted_20))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 2 /* CLASS */), [
                        [_vModelSelect, _ctx.role.zone_id]
                      ]),
                      _createCommentVNode(" ERRORS "),
                      (_ctx.errors?.zone_id ?? false)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.zone_id, (error) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: error,
                                class: "small text-danger lh-1 m-0 mt-1"
                              }, _toDisplayString(error), 1 /* TEXT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_SpinnerLoading)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createCommentVNode(" DELETE "),
                    (_ctx.update)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('cta.delete_role')), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_28)),
                    _createCommentVNode(" SAVE "),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_DiscardButton, {
                        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ path: '/system-roles' })))
                      }),
                      _createElementVNode("button", {
                        class: "default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16",
                        type: "submit",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitted = true))
                      }, _toDisplayString(_ctx.$t('cta.save_role')), 1 /* TEXT */)
                    ])
                  ])
                ]))
          ])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('error.something_went_wrong')), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ]),
    _createVNode(_component_ConfirmModal, {
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteRole())),
      title: _ctx.$t('cta.$delete.title'),
      message: _ctx.$t('cta.$delete.message')
    }, null, 8 /* PROPS */, ["title", "message"]),
    (_ctx.update && (_ctx.role as RoleInfo).type == _ctx.Role.hcp)
      ? (_openBlock(), _createBlock(_component_RolePermissions, {
          key: 0,
          id: (_ctx.role as RoleInfo).id
        }, null, 8 /* PROPS */, ["id"]))
      : _createCommentVNode("v-if", true),
    (_ctx.update && (_ctx.role as RoleInfo).type != _ctx.Role.admin)
      ? (_openBlock(), _createBlock(_component_RoleConsents, {
          key: 1,
          role: _ctx.role as RoleInfo,
          id: (_ctx.role as RoleInfo).id
        }, null, 8 /* PROPS */, ["role", "id"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}